export default __webpack_public_path__ + "static/estimulacao-seguranca-afeto-ea6f98cf3d0161dc2657cba941ee7278.png";